import * as React from "react"
import { cn } from "../../lib/utils"

const Button = React.forwardRef(({ className, variant = "default", size = "button", ...props }, ref) => {
  const variants = {
    default: "btn-primary-neon",
    destructive: "bg-destructive text-destructive-foreground hover:bg-destructive-hover",
    success: "bg-success text-success-foreground hover:bg-success-hover",
    warning: "bg-warning text-warning-foreground hover:bg-warning-hover",
    outline: "btn-glassy-secondary",
    secondary: "btn-glassy-secondary",
    ghost: "hover:bg-muted hover:text-foreground",
    link: "text-primary underline-offset-4 hover:underline",
    primaryPurple: "btn-primary-base btn-primary-purple",
    primaryNeon: "btn-primary-neon",
    alternatePrimary: "btn-primary-base btn-alternate-primary",
  }

  const sizes = {
    button: "h-10 px-6 py-2",
    small: "h-9 px-4 text-sm",
    sm: "h-8 px-2.5 py-1.5 text-sm",
    md: "h-9 px-5 py-2 text-sm",
    large: "h-11 px-8 text-base",
    jumbo: "h-12 px-10 text-lg",
    icon: "h-10 w-10",
  }

  return (
    <button
      className={cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 data-[force-focus=true]:outline-none data-[force-focus=true]:ring-2 data-[force-focus=true]:ring-ring data-[force-focus=true]:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        sizes[size],
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button }
